import React from "react";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import "./PricingSection2.scss";

function PricingSection2(props) {
  const plans = [
    {
      id: "accountable-ai",
      image: "/ai_graphic1.svg",
      name: "Accountable AI Web App",
      perks: [
        "Register and copyright your works as legally enforceable IP",
        "Support for images and text files",
        "Sell or license access rights to your work to LLMs and GPT applications",
        "Receive royalties for usage and output similarity matching"
      ],
    },
    {
      id: "ai-license-manager",
      image: "/ai_graphic1.svg",
      name: "API Toolkit for AI License Management",
      perks: [
        "Upload and/or register bulk data and metadata as IP assets",
        "Buy and sell LLM training access to datasets in bulk or by the record",
        "Track/audit license deals and asset usage",
        "Settle royalty payments simultaneously for all stakeholders in real time",
      ],
    },
    {
      id: "gpt-portal",
      image: "/ai_graphic1.svg",
      name: "GPT Portal",
      perks: [
        "Use our GPT application to generate text and images from LLMs trained on data/IP registered on PDS.",
        "Compensate creators whose works were used in LLM training for any commercial usage of the output content.",
      ],
    },
  ];

  return (
    <Section
      id="pricing2"
      color={props.color}
      size={props.size}
      backgroundImage={props.backgroundImage}
      backgroundImageOpacity={props.backgroundImageOpacity}
    >
      <div className="container">
      <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={3}
          spaced={true}
          className="has-text-centered"
        />
        <div className="columns is-centered is-variable is-4 is-desktop">
          {plans.map((plan, index) => (
            <div
              className="PricingSection2__column column is-one-third-desktop"
              key={index}
            >
              <div className="PricingSection2__card card">
                <div className="PricingSection2__card-content card-content">
                  <div className="PricingSection2__image-container image">
                    <img className="PricingSection2__image"
                      src={plan.image} alt="Logo" 
                    />
                  </div>
                  <br />
                  <div className="PricingSection2__name has-text-weight-bold">
                    {plan.name}
                  </div>

                  {plan.description && (
                    <p className="PricingSection2__description">
                      {plan.description}
                    </p>
                  )}

                  {plan.perks && (
                    <ul className="PricingSection2__perks">
                      {plan.perks.map((perk, index) => (
                        <li key={index}>
                          <i className="fas fa-check has-text-primary" />
                          {perk}
                        </li>
                      ))}
                    </ul>
                  )}
                  <a
                    className="PricingSection2__button button is-medium is-primary"
                    href={`https://app.mysite.com/purchase/${plan.id}`}
                  >
                    Check it out
                  </a>
                </div>
                {index !== plans.length - 1 && (
                  <i className="fas fa-long-arrow-alt-right is-large is-primary arrow" />
                )}
                </div>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
}

export default PricingSection2;
